import { transformPadVisitToCalendarVisitSchedule } from './filterAndTransformPadVisitsToCalendarVisitSchedule';
import { shouldIncludeAsCalendarVisitScheduleCooperative } from './shouldIncludeAsCalendarVisitScheduleCooperative';

/**
 * Filters and transforms an array of padVisits based on context.
 */
export const filterAndTransformPadVisitsToCalendarVisitScheduleCooperative = padVisits => {
  if (!Array.isArray(padVisits)) return [];

  return padVisits
    .filter(padVisit => shouldIncludeAsCalendarVisitScheduleCooperative(padVisit))
    .map(transformPadVisitToCalendarVisitSchedule);
};
